import React from 'react';
import './DailyTimesheetForm.scss';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus } from '@fortawesome/free-solid-svg-icons';
import DailyTimesheetDeleteButton from './DailyTimesheetDeleteButton';

export default class DailyTimesheetHeader extends React.Component {
    render() {
        const { dailyTimesheet } = this.props;

        const displayDate = moment(dailyTimesheet.date).format(
            MomentDateFormat.WeekDayNameAndDate
        );

        return (
            <div className="mt-3 ml-1 daily-timesheet-header">
                <h3>
                    <div className="d-flex">
                        <div>
                            <FontAwesomeIcon
                                icon={faCalendarPlus}
                                className="mr-1"
                            />
                            {!dailyTimesheet.createdByCurrentUser &&
                                dailyTimesheet.employeeName && (
                                    <>{dailyTimesheet.employeeName}'s </>
                                )}
                            Timesheet - {displayDate}
                        </div>
                        <div className="ml-auto">
                            <DailyTimesheetDeleteButton {...this.props} />
                        </div>
                    </div>
                </h3>
            </div>
        );
    }
}

